import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Divider, Modal } from 'antd';
import { EXPORT_COLUMNS, loadExportColumnKeys, saveExportColumnKeys } from '../qv4/exportColumns';
import useSnackbar from '../Snackbar/UseSnackbar';

// Per-user settings, stored client-side in localStorage (keyed by user id) —
// unlike SettingsModal.js (Global Settings), nothing here is saved to the
// backend, so every option added here should be a personal UI/export
// preference, not something that needs to apply to other users.
const settingsOptions = [
    { id: 1, name: "Customize PDF/Excel columns" },
];
const MODAL_WIDTH = 'min(1200px, 96vw)';
const MODAL_HEIGHT = 'calc(100vh - 24px)';

const UserSettingsModal = ({ open_settings, handleCloseSettingsModal, authState }) => {
    const { SuccessSnackbar } = useSnackbar();
    const [selectedOption, setSelectedOption] = useState(settingsOptions[0].id);
    const [enabledKeys, setEnabledKeys] = useState([]);

    useEffect(() => {
        if (open_settings) setEnabledKeys(loadExportColumnKeys(authState?.id));
    }, [open_settings, authState?.id]);

    const toggleColumn = (key, checked) => {
        setEnabledKeys(prev => checked ? [...prev, key] : prev.filter(k => k !== key));
    };

    const handleSave = () => {
        saveExportColumnKeys(authState?.id, enabledKeys);
        SuccessSnackbar("Saved Settings Successfully!");
        handleCloseSettingsModal();
    };

    const renderDetails = () => {
        switch (selectedOption) {
            case 1:
                return (
                    <div className='p-2 drop-shadow'>
                        <h5>Customize PDF/Excel columns</h5>
                        <Divider type='horizontal' className='p-0 m-0 mt-1 mb-2' style={{ backgroundColor: "black" }} />
                        <div style={{ fontSize: 12, color: "gray", marginBottom: 10 }}>
                            Choose which columns show up when you export queries (Table view → PDF/Excel icon
                            → Export / Send Queries). SlNo is always included. Saved on this device/browser only.
                        </div>
                        <div className='border rounded p-2'>
                            {EXPORT_COLUMNS.map(col => (
                                <div key={col.key} className='p-2 mb-1' style={{ borderBottom: "1px solid #eee" }}>
                                    <Checkbox
                                        checked={enabledKeys.includes(col.key)}
                                        onChange={(e) => toggleColumn(col.key, e.target.checked)}
                                    >
                                        {col.label}
                                    </Checkbox>
                                </div>
                            ))}
                        </div>
                    </div>
                );
            default:
                return <div>Keep calm, coffee is being converted to code...</div>;
        }
    };

    return (
        <Modal
            title="User Settings"
            centered
            open={open_settings}
            onCancel={handleCloseSettingsModal}
            maskClosable={false}
            width={MODAL_WIDTH}
            styles={{
                content: { height: MODAL_HEIGHT, maxHeight: MODAL_HEIGHT, display: 'flex', flexDirection: 'column' },
                body: { flex: 1, minHeight: 0, overflow: 'hidden' },
            }}
            footer={
                <div className="flex justify-end">
                    <Button type="primary" onClick={handleSave}>
                        Save Changes
                    </Button>
                </div>}
        >
            <div className='border rounded p-2 drop-shadow' style={{ backgroundColor: "#f7f7f7", height: '100%', minHeight: 0 }}>
                <div className='drop-shadow flex gap-3' style={{ display: 'flex', height: '100%', minHeight: 0 }}>
                    {/* Menu Pane */}
                    <div className='border rounded p-2' style={{ width: '200px', backgroundColor: "#fefefe", overflowY: 'auto' }}>
                        <div className='flex justify-center'>Menu Items</div>
                        <Divider type='horizontal' className='p-0 m-0 mt-1 mb-2' style={{ backgroundColor: "black" }} />
                        <ul style={{ listStyleType: 'none', padding: 0 }}>
                            {settingsOptions.map(option => (
                                <li key={option.id}
                                    style={{
                                        padding: '10px',
                                        borderRadius: "8px",
                                        cursor: 'pointer',
                                        backgroundColor: selectedOption === option.id ? '#404040' : 'transparent',
                                        transition: "background-color 0.3s, color 0.3s ease-in-out",
                                        color: selectedOption === option.id ? 'white' : 'black',
                                    }}
                                    onClick={() => setSelectedOption(option.id)}>
                                    {option.name}
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className='m-0' style={{ display: "flex", alignItems: "center", height: "100%" }}>
                        <Divider type='vertical' style={{ backgroundColor: "black", height: "95%" }} />
                    </div>

                    {/* Details Pane */}
                    <div className='border rounded p-2' style={{ backgroundColor: "#fbfbfb", flex: 1, minWidth: 0, overflowY: "auto" }}>
                        {renderDetails()}
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default UserSettingsModal;
